<template>
    <NuxtLayout name="malt-full-layout">
        <div class="profile-id-or-alias">
            <slot />
        </div>
        <ClientOnboarding />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {ClientOnboarding} from '#components';
</script>
